/**
 * Returns a human readable formatted percent based on a float number between 0 and 1.
 * @param {number} number to be delimeted.
 */
export default function (number) {
  const formatter = new Intl.NumberFormat('en-US');
  return formatter.format(number);
}
